import React from 'react';
import { ListModel, RadioInputWrapper, NotResults } from './styled';

interface Props {
  dataList: any[];
  activeItem?: number;
  handleChange?: Function;
  showFirstItems?: number;
  className?: string;
  themeColor?: string;
}

export const SearchResultsModal: React.FC<Props> = ({
  dataList,
  handleChange,
  activeItem,
  showFirstItems,
  className,
  themeColor
}) => {

  const getText = (ubigeo: string) => ubigeo ? `, ${ubigeo}` : '';

  const createElement = (district?: string, province?: string, department?: string) => {
    const element =  `<span>${district}</span>${getText(province)}${getText(department)}`;
    return element;
  }

  return (
    <ListModel showFirstItems={showFirstItems} className={className}>
      {
        dataList && dataList.length > 0 && dataList.map((element, index) => (
          <RadioInputWrapper
            name="ubigeo"
            key={index}
            data-index={index}
            tabIndex="-1"
            activeSuggestion={index === activeItem ? true : false}
            value={element.id}
            contentLeft
            colorActive={themeColor}
            checked={index === activeItem ? true : false}
            handleChange={value => handleChange(value, index)}
          >
            <p dangerouslySetInnerHTML={
              {
                __html: createElement(
                  element.name
                )
              }} />
          </RadioInputWrapper>
        ))
      }
      { dataList && dataList.length === 0 && <NotResults   dangerouslySetInnerHTML={{
        __html: 'No se encontraron resultados.'
      }} />}
    </ListModel>
)};

SearchResultsModal.defaultProps = {
  showFirstItems: 2
}
